import { updateSecurity, updateTheftContentsSI, updateTobaccoSI } from '../../slices/coverDetails';
import { AppDispatch } from '../../store';
import { Risk } from '../../types/policy';
import { RiskDetailBPKTheftMoneyGlass } from '../../types/risk';

export const updateTheftCoverAction = ({
  risk,
  dispatch,
}: {
  risk: Risk | undefined;
  dispatch: AppDispatch;
}) => {
  const theftMoneyGlassRiskDetails = (risk?.riskDetail as RiskDetailBPKTheftMoneyGlass | undefined)
    ?.riskBPKTheftMoneyGlass;
  const { theft: theftDetails } = theftMoneyGlassRiskDetails ?? {};
  const { contentsSI, tobaccoSI, security } = theftDetails!;

  dispatch(updateTheftContentsSI(contentsSI));
  tobaccoSI && dispatch(updateTobaccoSI(tobaccoSI));
  dispatch(updateSecurity(security));
};
